import {
  Modal,
  ModalContent,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import ButtonMinor from '../../../components/ButtonMinor';
import {
  sendAudioClick,
  sendWorldJoin,
} from '../../../vuplex';
import {fontFamily} from './config';
import Emoji from './Emoji';
import SpaceportWorldCard from './SpaceportWorldCard';

const ConfirmModal = ({world = null, onClose}) => {
  const handleConfirmClick = (evt) => {
    sendWorldJoin({
      isPrivate: world.rules.isPrivate,
      name: world.name,
      worldId: world._id,
      worldType: world.rules.worldType,
    });

    sendAudioClick(evt);

    onClose();
  };

  return (
    <Modal
      isOpen={!!world}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay
        background="none"
      />

      {world && (
        <ModalContent
          bg="black"
          borderRadius="2xl"
          marginBottom="0.5rem"
          fontFamily={fontFamily}
        >
          <SpaceportWorldCard world={world}/>

          <Stack gap={4} justifyContent="center">
            <ButtonMinor
              bg="#fdf51b"
              borderRadius="none"
              h="4em"
              onClick={handleConfirmClick}
              tooltip="Join room."
            >
              <Emoji>✔</Emoji>&nbsp;Go to {world.name}
            </ButtonMinor>

            <ButtonMinor
              bg="#fdf51b"
              borderRadius="none"
              h="4em"
              onClick={() => {
                onClose();
              }}
            >
              <Emoji>❌</Emoji>&nbsp;Cancel
            </ButtonMinor>
          </Stack>
        </ModalContent>
      )}
    </Modal>
  );
};

export default ConfirmModal;
